import { APP_INITIALIZER, NgModule } from '@angular/core';
import { of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

import { UserModel } from '../models/user.model';

import { AuthSessionService } from './auth-session.service';

/**
 *
 * @param authSessionService
 */
export function authSessionFactory(authSessionService: AuthSessionService) {
  return (): Promise<unknown> => {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser')) as UserModel;
    if (!currentUser?.userAccount) {
      return authSessionService
        .getUser()
        .pipe(
          switchMap((data: any) => {
            return authSessionService.getUserClaims().pipe(
              switchMap((claim: any) => {
                const res: { userAccount: UserModel } = data.Result;
                res.userAccount.userClaims = claim;
                sessionStorage.setItem('currentUser', JSON.stringify(res.userAccount));

                return of(true);
              }),
              catchError(() => of(false))
            );
          }),
          catchError(() => of(false))
        )
        .toPromise();
    }

    return of(false).toPromise();
  };
}

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: authSessionFactory,
      deps: [AuthSessionService],
      multi: true,
    },
  ],
})
export class AuthSessionModule {}
